import React from "react";

export type TabId = 'day' | 'week' | 'month' | 'accumuli';
type TabsType = { tabId: TabId, tabName: string, href: string, showTab: boolean };

interface TabsRiepilogoProps {
    // children: ReactNode;
    activeTab: TabId;
    setActiveTab: (tabId: TabId) => void;
    showTabAccumuli?: boolean;
}

function classNames(...classes: any) {
    return classes.filter(Boolean).join(' ')
}

export const TabsRiepilogo: React.FC<TabsRiepilogoProps> = (props: TabsRiepilogoProps) => {


    const tabs: TabsType[] = [
        {tabId: 'day', tabName: 'Giornaliero', href: '#', showTab: true},
        {tabId: 'week', tabName: 'Settimanale', href: '#', showTab: true},
        {tabId: 'month', tabName: 'Mensile', href: '#', showTab: true},
        {tabId: 'accumuli', tabName: 'Accumuli', href: '#', showTab: props.showTabAccumuli || true},
    ]

    return <div className="w-fit mr-5 content-center ml-auto">
        <div className="sm:hidden">
            <select id="tabsRiepilogo" name="tabsRiepilogo" value={props.activeTab}
                    className="text-xs block w-full rounded-md border-gray-300 py-1 pl-1 pr-6 focus:border-blue-500 focus:outline-none focus:ring-blue-500"
                    onChange={(e) => props.setActiveTab(e.target.value as TabId)}>
                {tabs.map((item, index) => {
                    if (item.showTab)
                        return <option key={index} value={item.tabId}>{item.tabName}</option>
                    else return null
                })}
            </select>
        </div>

        <div className="hidden sm:block">
            <div className="border-r border-gray-200">
                <nav className="-mr-py flex flex-col">
                    {tabs.map((tab) => {
                        if (tab.showTab)
                            return <a key={tab.tabId}
                                      onClick={() => props.setActiveTab(tab.tabId)}
                                      className={classNames(
                                          (tab.tabId === props.activeTab) ? 'border-elemPresenze text-elemPresenze' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                                          tab.tabId === 'accumuli' ? 'italic' : '',
                                          (tab.tabId === 'accumuli' && (tab.tabId === props.activeTab)) ? '!border-blue-500 !text-blue-500' : '',
                                          'group inline-flex items-center border-r-2 px-1 py-2 font-medium',
                                      )}>
                                <span className="whitespace-nowrap">{tab.tabName}</span>
                            </a>
                        else return null
                    })}
                </nav>
            </div>
        </div>
    </div>
};

export default TabsRiepilogo;